import { RequestConsultaPrimeiraHabilitacao } from 'store/modules/api/detranCnh/primeiraHabilitacao/consultaPrimeiraHabilitacao/types';
import { validaCpf } from 'utils/genericFunctions';
import * as Yup from 'yup';

export const initialValues: RequestConsultaPrimeiraHabilitacao = {
	cpf: '',
	usuario: '',
	senha: '',
};

export const schema = Yup.object<RequestConsultaPrimeiraHabilitacao>().shape({
	cpf: Yup.string()
		.required('Campo Obrigatório: CPF.')
		.test({
			name: 'cpfValidation',
			exclusive: true,
			message: 'CPF digitado inválido.',
			test: value => validaCpf(value),
		}),
});
